<template>
    <div>
        <v-row :justify="justify">
            <!-- INCLUDE AUTOCOMPLETE -->
            <v-col :cols="cols">
                <BaseEditPageAutocomplete
                    :context="context"
                    field="Include"
                    :label="$t(includeLabel)"
                    :withMargin="false"
                    :multiple="true"
                    :withFreeText="false"
                    :isLoading="true"
                    :returnObject="false"
                    :rules="rules"
                    :alvqa="alvqa+'-dropdown-regions-include'"
                >
                    <template v-slot:selection></template>
                    <template v-slot:items="{ items }">
                        <v-list-item-content>
                            <v-list-item-title>
                               {{ items.text }} ({{ items.value }})
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                </BaseEditPageAutocomplete>
            </v-col>
            <!-- ExCLUDE AUTOCOMPLETE -->
            <v-col :cols="cols">
                <BaseEditPageAutocomplete
                    :context="context"
                    field="Exclude"
                    :label="$t(excludeLabel)"
                    :withMargin="false"
                    :multiple="true"
                    :withFreeText="false"
                    :isLoading="true"
                    :returnObject="false"
                    :rules="rules"
                    :alvqa="alvqa+'-dropdown-regions-exclude'"
                >
                    <template v-slot:selection></template>
                    <template v-slot:items="{ items }">
                        <v-list-item-content>
                            <v-list-item-title>
                               {{ items.text }} ({{ items.value }})
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                </BaseEditPageAutocomplete>
            </v-col>
        </v-row>
        <v-row v-if="showSelectedRegions()" class="mt-0">
            <v-col :cols="cols" class="mt-0">
                <span v-for="(region, index) in includedRegions" :key="index">
                    <v-chip 
                        color="iconStandard" 
                        close
                        text-color="white"
                        @click:close="remove(region, index, 'in')"
                        class="mr-2"
                    >
                        {{ getRegionDisplayName(region) }}
                    </v-chip>
                </span>
            </v-col>
            <v-col>
                <span v-for="(region, index) in excludedRegions" :key="index">
                    <v-chip 
                        color="iconStandard" 
                        close
                        text-color="white"
                        @click:close="remove(region, index, 'ex')"
                        class="mr-2"
                    >
                        {{ getRegionDisplayName(region) }}
                    </v-chip>
                </span>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'

export default {
    name: "BaseRegions",
    components: {
        BaseEditPageAutocomplete
    },
    props: {
        context: String,
        includeLabel: {
            type: String,
            default: 'lang_GENERAL_CAPTION_INCLUDE'
        },
        excludeLabel: {
            type: String,
            default: 'lang_GENERAL_CAPTION_EXCLUDE'
        },
        cols: {
            type: String,
            default: "5"
        },
        justify: String,
        alvqa: {
            type: String,
            default: ''
        },
        rules: {
            type: [Object, String],
            default: ""
        },
    },
    computed: {
        includedRegions: {
            get() { return this.$store.getters['get'+ this.context+'DetailsInclude'] },
            set(region) { this.$store.commit('set'+ this.context+'DetailsInclude') }
        },
        excludedRegions: {
            get() { return this.$store.getters['get'+ this.context+'DetailsExclude'] },
            set(region) { this.$store.commit('set'+ this.context+'DetailsExclude') }
        }
    },
    methods: {
        getRegionDisplayName(code) {
            const regionGroups = {
                'WELT': { de: 'Welt',                  en: 'World' },
                'DACH': { de: 'DACH',                   en: 'GAS' },
                'EUR':  { de: 'Europa',                 en: 'Europe' },
                'MEA':  { de: 'Naher Osten & Afrika',   en: 'Middle East & Africa' },
            }
            if (regionGroups[code]) {
                const lang = (this.$i18n.locale === 'de') ? 'de' : 'en'
                return regionGroups[code][lang]
            }
            const translated = this.$alvPlugin.getTranslatedCountryName(code, true)
            return translated || code
        },
        remove(item, index, context) {
            if(index >= 0) this[context+'cludedRegions'].splice(index, 1)
        },
        showSelectedRegions() {
            return (
                    this.includedRegions !== null &&  
                    this.includedRegions.length !== 0 ||
                    this.excludedRegions !== null &&
                    this.excludedRegions.length !== 0
            )
        }
        
    }
}
</script>